const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      if (search.column.head === "실시기간") {
        conditions.push({ key: "body.subInfo.실시기간.sDate", operator: "LIKE", value: `%${search.column.keyword}%` });
        conditions.push({ key: "body.subInfo.실시기간.eDate", operator: "LIKE", value: `%${search.column.keyword}%` });
      } else conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.subInfo.구분",
      },
      {
        name: "실시기간",
        key: "body.subInfo.실시기간",
      },
      {
        name: "점검업체",
        key: "body.subInfo.점검업체",
      },
      {
        name: "첨부",
        key: "body.subInfo.구분",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).subInfo.구분; // 구분
        case 3:
          if (func.getContent(value).subInfo.실시기간.sDate || func.getContent(value).subInfo.실시기간.sDate) return `${func.getContent(value).subInfo.실시기간.sDate} ~ ${func.getContent(value).subInfo.실시기간.eDate}`; // 실시기간
          else return "";
        case 4:
          return func.getContent(value).subInfo.점검업체; // 점검업체
        case 5:
          // 파일첨부
          const file = func.getContent(value).fileList[0];
          return { type: "docs", file: { ...file, fileName: file.name } };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
